var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-card',[_c('base-label',{attrs:{"text":"Defina um intervalo de contemplação"}}),_c('base-input',{attrs:{"label":"Intervalo de contemplação","money-mask":_vm.StringLanguage.timeConfigs.days,"thousandSeparator":false},model:{value:(_vm.newInterval),callback:function ($$v) {_vm.newInterval=$$v},expression:"newInterval"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }